export default __webpack_public_path__ + "static/media/eco-sub-image-02.8d55a1ca.png";